import { useState } from 'react';
import InputForm from '../../../../InputT';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import DataType from '../../../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress} from '@mui/material';
import SearchInput from '../../../../SearchInput';
import SearchModal from '../../../../SearchModal';
import Table, { ColumnsType } from 'antd/es/table';
import { NightShelterOutlined, FoodBank, Numbers } from '@mui/icons-material';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Cheque from '../../../../../Models/Cheque';
import SelectOption from '../../../../SelectOption';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import axios from 'axios';

const Swal = require('sweetalert2');
let Link = require('../../../../../Data/Data.json');


const Tab1 = (props: { etatG: boolean, form?: any, DataCheque: Cheque[] ,OnModif:Function}) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [Filtre, setFiltre] = useState<string>("1");
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const authHeader = useAuthHeader();
  const [Option, setOption] =useState<[]>([]);

const HandlerChangeBank= ()=>{
    //setLoad(true);
    let init=props.form.getFieldValue("BANCLT");

    var data = { CodeAgence: user.codage, Table: "BANQUE" ,Colonne1: "CODCPT", Colonne2: "LIBELL", Colagence: "AGECPT", Init:init, choix:34 }

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Link.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(data))
      }
    };
    
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              let datas = res.Result.Table[0];

              if (datas.length === 0) {
                //console.log("aucun élément ");
                //SetData(datat)
              }
              else {
                props.form.setFieldsValue({"CPTCHQRECOUVRE":datas.CPTCHQRECOUVRE,"lib_CPTCHQRECOUVRE":datas.LIBELL});
              }
            }
          }
     //    setLoad(false);
        }).catch((error) => {
          console.log(error)
          //setLoad(false);
          // SweetAlert.fire({title: "Error", text : error})
        })

}

  const HandlerClient=()=>{
   
    let NUMCLI=props.form.getFieldValue("NUMCLI");
    setFiltre(NUMCLI);
  }

  //Initialisation des parametres de recherche 
  let searchOp    : ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
  let searchBanque: ParamsPicklist = { CodeAgence: user.codage, Table: "BANQUE", Colonne1: "CODCPT", Colonne2: "LIBELL", Colagence: 'AGECPT', Choix: 22 }
  let searchCompte: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "",colfiltre:'NUMCLI',valfiltre:Filtre, Choix: 22 }
  let searchClient: ParamsPicklist = { CodeAgence: user.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "CODAGE", Choix: 22 }

  const columns: ColumnsType<Cheque> = [
    {
      title: 'Date Opération',
      dataIndex: 'DATOPE',
      ellipsis: true,
      width: 100,
      render: (text: any, reccord: any) => (
        <span>
          {ReformatDate(text)}
        </span>
      )
    }
    ,
    {
      title: 'BANQUE',
      dataIndex: 'Lib_BANQUE',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Montant',
      dataIndex: 'MONTAN',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'N° Compte',
      dataIndex: 'NUMCPT',
      ellipsis: true,
      width: 150,
      // filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.NUMCPT)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.SENSEC)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.REPECE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.MONTANT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.LIBELL)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Utilis)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Motif)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    },
    {
      title: 'N° Chèque',
      dataIndex: 'NUMCHQ',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'N° Cpt En cheque',
      dataIndex: 'CPTCHC',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Compte Client Banque',
      dataIndex: 'CPTCLT',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Remettant',
      dataIndex: 'REMETT',
      ellipsis: true,
      width: 150,
    },
    {
      title: "",
      dataIndex: 'RelObject',
      width: 1
    }
  ];

  let informationclient = {
    searchCodeOpe: {
      Titre: "Recherche Opération",
      label: "Opération",
      name: "CODOPE", params: searchOp
    },
    searchBanque: {
      Titre: "Recherche Banque",
      label: "Banque de dépot",
      name: "BANCLT", params: searchBanque
    },
    searchCptClient: {
      Titre: "Recherche Compte Client ",
      label: "Compte Client",
      name: "NUMCPT", params: searchCompte
    },
    searchCompteClient: {
      Titre: "Recherche Client à Recevoir",
      label: "Compte chèque Banque a recouvrer",
      name:  "CPTCHQRECOUVRE", params: searchCompte
    },
    searchCompteRecouvrir: {
      Titre: "Recherche Compte chèque à  l'encaissement",
      label: "Compte  chèq client l'encaissement",
      name:  "CPTCHC", params: searchCompte
    },
    searchClient: {
      Titre: "Recherche Client",
      label: "Client ",
      name:  "NUMCLI", params: searchClient
    },
    InputDateOpe: {
      label: "Date Opération",
      name:  "DATOPE"
    },
    InputMontant: {
      label: "Montant",
      name:  "MONTAN"
    },
    InputRemettant: {
      label: "Remettant",
      name:  "REMETT"
    },
    InputNumcheque: {
      label: "Numéro de chèque ",
      name:  "NUMCHQ"
    },
    InputCptClientBanque: {
      label: "Compte Client à la Banque",
      name:  "CPTCLT"
    }
  }

  const [selectedRowKeys, setSelectedRowKeys] =  useState<React.Key[]>([]);
  
  const onSelectChange = (newSelectedRowKeys:any) => {
    // console.log('selectedRowKeys changed: ', Data[newSelectedRowKeys]);
    props.form.setFieldsValue(props.DataCheque[newSelectedRowKeys].RelObject);
    props.form.setFieldValue('DATOPE',ReformatDate(props.DataCheque[newSelectedRowKeys].DATOPE));
    props.form.setFieldValue('lib_CPTCHC',props.DataCheque[newSelectedRowKeys].RelObject.lib_BANCLT);
    props.form.setFieldValue('lib_CPTCHQRECOUVRE',props.DataCheque[newSelectedRowKeys].RelObject.lib_BANCLT);
    props.form.setFieldValue('lib_CODOPE',props.DataCheque[newSelectedRowKeys].RelObject.LIBECR);
    setSelectedRowKeys(newSelectedRowKeys);
    props.OnModif();
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  

  return (
    <div className='tabItem' >
      <Box fontStyle="inherit" className='border-eft border' width={"85%"} position={"absolute"} sx={{p: 1}} >
        <legend> Saisie chèque client </legend>
         <Box fontStyle="inherit" className='border' width={"100%"}  >
         <SearchInput width={3}  dissabledLib={false}   dissabledCode notRequired form={props.form}  Titre={informationclient.searchCodeOpe.Titre} label={informationclient.searchCodeOpe.label} name={informationclient.searchCodeOpe.name} Parametre={informationclient.searchCodeOpe.params} />
        
        <Box style={{ display: 'flex' }}    >
          <Box fontStyle="inherit" className='border-left' width={'50%'} >
            {/* <SearchInput dissabledLib={false}  dissabledCode notRequired form={props.form} width={6} Titre={informationclient.searchCodeOpe.Titre} label={informationclient.searchCodeOpe.label} name={informationclient.searchCodeOpe.name} Parametre={informationclient.searchCodeOpe.params} /> */}
            <SearchModal disabled={props.etatG}  form={props.form} ExecuteafterSelect1={HandlerClient} width={6} Titre={informationclient.searchClient.Titre} label={informationclient.searchClient.label} name={informationclient.searchClient.name} Parametre={informationclient.searchClient.params} />
            <SelectOption Size={'middle'}  Option={Option} width={6}  label={informationclient.searchCptClient.label} name={informationclient.searchCptClient.name} Parametre={informationclient.searchCptClient.params} />
            <InputForm icon={<Numbers />} width={6} label={informationclient.InputNumcheque.label} name={informationclient.InputNumcheque.name} type='number' />
            {/* <SelectOption Size={'middle'}  width={9}  label={informationclient.searchCompteRecouvrir.label} name={informationclient.searchCompteRecouvrir.name} Parametre={informationclient.searchCompteRecouvrir.params} /> */}
            <InputForm  notRequired icon={<FoodBank />} width={6} label={informationclient.InputCptClientBanque.label} name={informationclient.InputCptClientBanque.name} type='text' />
            
            <InputForm icon={<NightShelterOutlined />} width={6} label={informationclient.InputRemettant.label} name={informationclient.InputRemettant.name} type='TextArea' />
          </Box>
          <Box fontStyle="inherit" className='border-left' width={'50%'}>
            <SearchModal form={props.form} width={9} ExecuteafterSelect1={HandlerChangeBank} Titre={informationclient.searchBanque.Titre} label={informationclient.searchBanque.label} name={informationclient.searchBanque.name} Parametre={informationclient.searchBanque.params} />
            <SearchModal form={props.form} disabled width={9} Titre={informationclient.searchCompteClient.Titre} label={informationclient.searchCompteClient.label} name={informationclient.searchCompteClient.name} Parametre={informationclient.searchCompteClient.params} />
            <InputForm icon={<NightShelterOutlined />}  disabled width={9} label={informationclient.InputDateOpe.label} name={informationclient.InputDateOpe.name} type='date' />
            <InputForm icon={<NightShelterOutlined />} money width={9} label={informationclient.InputMontant.label} name={informationclient.InputMontant.name} type='number' />
            <Box sx={{visibility:'hidden'}} >
            <InputForm width={9} notRequired label={informationclient.InputRemettant.label} name={"Id"} type='text' />
            </Box>
          </Box>
        </Box>

         </Box>
       
        <Box fontStyle="inherit" className='border' width={"100%"} sx={{mb:1, p: 1}} >

          <Table sticky={true} columns={columns}
          //  rowSelection={{ type: 'radio', ...rowSelection,getCheckboxProps:(reccord)=>({disabled: false}) }}
            size='small' style={{ width: '100%' }} pagination={false}  scroll={{ y: 200, x: 1200 }} dataSource={props.DataCheque} />
        </Box>

      </Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
        <CircularProgress color="inherit" />
      </Backdrop>
  
    </div>
  );
}
export default Tab1;
